import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _map from "lodash/map";
import _mapValues from "lodash/mapValues";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { CHECK_EXERCISE, ORDER_GROUPED_ITEMS, SET_ITEM_OFFSET, SHOW_EXERCISE, SHOW_SOLUTION, UPDATE_LOST_XP } from '../actions/types';
const initialState = {};
const defaults = {
  lostXp: 0,
  solutionShown: 0
};
export default (function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CHECK_EXERCISE:
      {
        const lastSubmission = {
          message: action.message,
          success: action.success
        };
        if (action.success) {
          return _objectSpread(_objectSpread({}, state), {}, {
            [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
              groupedItems: action.groupedItems,
              lastSubmission
            })
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
            groupedItems: action.groupedItems,
            lastSubmission
          })
        });
      }
    case ORDER_GROUPED_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
          groupedItems: action.groupedItems
        })
      });
    case SET_ITEM_OFFSET:
      {
        const {
          groupedItems
        } = state[action.id];
        const newGroupedItems = _mapValues(groupedItems, items => _map(items, item => _objectSpread(_objectSpread({}, item), {}, {
          offset: item.id === action.itemId ? action.offset : item.offset
        })));
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
            groupedItems: newGroupedItems
          })
        });
      }
    case SHOW_EXERCISE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.id]: _objectSpread(_objectSpread({}, defaults), state[action.id])
      });
    case SHOW_SOLUTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread(_objectSpread({}, defaults), state[action.exerciseId]), {}, {
          solutionShown: state[action.exerciseId].solutionShown + 1
        })
      });
    case UPDATE_LOST_XP:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread(_objectSpread({}, defaults), state[action.exerciseId]), {}, {
          lostXp: action.lostXp
        })
      });
    default:
      return state;
  }
});